import {
    get,
    post,
    getBlob
} from '@/utils/request'

const SERVICE_URL = '/settlement-service/v1'

export function deleteBatch(params, pathParam) {
    return get(SERVICE_URL + '/account/deleteBatch', params, pathParam)
}
export function queryById(params, pathParam) {
    return get(SERVICE_URL + '/account/getById', params, pathParam)
}
export function list(params) {
    return post(SERVICE_URL + '/account/list', params)
}
export function add(params) {
    return post(SERVICE_URL + '/account/add', params)
}
export function edit(params) {
    return post(SERVICE_URL + '/account/editAccount', params)
}



export function deletePartBatch(params, pathParam) {
    return get(SERVICE_URL + '/accountPartList/deleteBatch', params, pathParam)
}
export function queryPartById(params, pathParam) {
    return get(SERVICE_URL + '/accountPartList/getById', params, pathParam)
}
export function listPart(params) {
    return post(SERVICE_URL + '/accountPartList/list', params)
}
export function addPart(params) {
    return post(SERVICE_URL + '/accountPartList/add', params)
}
export function editPart(params) {
    return post(SERVICE_URL + '/accountPartList/edit', params)
}
//结算单查询导出
export function exportSettlementData(params) {
    return post(SERVICE_URL + '/account/exportSettlement', params)
}
//异步导出结算单（返回 taskId）
export function exportSettlementDataAsync(params) {
    return post(SERVICE_URL + '/account/exportSettlementDataAsync', params)
}
//查询导出任务状态
export function getExportTask(taskId) {
    return get(SERVICE_URL + '/account/exportTask/' + taskId)
}
//下载导出文件（返回 Blob，文件名由后端 Content-Disposition 控制）
export function downloadExportFile(taskId) {
    return getBlob(SERVICE_URL + '/account/downloadFile', { taskId })
}
//补发邮件
export function pushEmail(params) {
    return post(SERVICE_URL + '/account/pushEmail', params)
}